/* MV Sortiment assets/mv-sortiment.e2.js - Agent T-E2 - 2026-10-04
 *
 * Kollektionsseite (sections/mv-kollektion-kopf.liquid in templates/collection.automaten.json):
 *  1. Vergleich bis 3 Produkte: Checkbox [data-mv-e2-wahl] an der Karte (snippets/mv-produktkarte.liquid,
 *     data-mv-e2-titel, data-mv-e2-bild), Leiste [data-mv-e2-leiste] am unteren Rand mit Bild, Name, Entfernen
 *     und dem Link <data-mv-e2-basis>?vergleich=h1,h2,h3 (erst ab 2 Produkten). Zustand je Kollektion in
 *     sessionStorage['mv-e2-vergleich'] = {v:1, k:{<kollektion>:[{h, t, b}]}}; ?vergleich= in der URL hat Vorrang.
 *     Ist die Auswahl voll, wird die vierte Checkbox zurueckgesetzt und angesagt (aria-live [data-mv-e2-meldung]).
 *  2. Vergleichsansicht [data-mv-e2-ansicht]: bei ?vergleich= eine Tabelle aus den inerten Vorlagen der Karten
 *     (template[data-mv-e2-daten="<handle>"]: bild, titel, preis, auswahlen, breite, temperatur, display, aktion)
 *     mit den Zeilen aus template[data-mv-e2-zeilen]. Je Merkmal ein tbody mit Kopfzeile (th scope=rowgroup) und
 *     Wertezeile, damit die Tabelle auch mobil in die Breite passt. Aenderungen der Auswahl schreiben die URL per
 *     history.replaceState nach und bauen die Tabelle neu.
 *  3. Sortierung "Meiste Auswahlen" (?sortierung=auswahlen): ordnet die Zellen von [data-mv-e2-raster] nach
 *     data-mv-auswahlen absteigend (stabil: Gleichstand in Server-Reihenfolge, ohne Wert ans Ende), setzt
 *     aria-current am Chip [data-mv-e2-sortierung="auswahlen"] und haengt den Parameter an die Filter-Chips
 *     ([data-mv-e2-filter] a), damit ein Filterklick die Sortierung behaelt. Paket K-9c (2026-10-13): Zellen mit
 *     data-mv-e2-fest (X10-Karte der Vorlage collection.automaten-alle) sortiert das Skript nicht, sie bleiben vorn.
 * Delegation auf document (change, click). Impact rendert Sektionen im Theme-Editor neu (shopify:section:load),
 * bfcache stellt alte Seiten wieder her (pageshow): danach wird aus dem Zustand neu gezeichnet.
 * Teil von assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge.
 * Unter Node (Tests) liefert die Datei nur die reinen Funktionen ueber module.exports.
 * Kommentare ASCII; sichtbare Texte als \u-Escapes, damit die Datei unabhaengig vom Zeichensatz bleibt.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-04.1';
  var MAX_STANDARD = 3;
  var SPEICHER = 'mv-e2-vergleich';
  var HANDLE = /^[a-z0-9][a-z0-9-]*$/;

  var TEXT = {
    hinzu: ' zum Vergleich hinzugef\u00fcgt.',
    weg: ' aus dem Vergleich entfernt.',
    leer: 'Vergleich geleert.',
    voll: 'H\u00f6chstens drei Produkte. Entfernen Sie zuerst eines.',
    entfernen: 'Entfernen',
    vergleich: 'Vergleich: '
  };

  // Handles aus "a,b,c": getrimmt, klein, gueltig, ohne Dubletten, hoechstens max
  function handlesAusText(text, max) {
    var grenze = max > 0 ? max : MAX_STANDARD;
    var aus = [];
    String(text === null || text === undefined ? '' : text).split(',').forEach(function (teil) {
      var h = teil.replace(/^\s+|\s+$/g, '').toLowerCase();
      if (HANDLE.test(h) && aus.indexOf(h) === -1 && aus.length < grenze) aus.push(h);
    });
    return aus;
  }

  // Wert eines Query-Parameters (null, wenn er fehlt); ohne URLSearchParams, damit Node und Browser gleich rechnen
  function parameter(suche, name) {
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    var paare = s.split('&');
    for (var i = 0; i < paare.length; i++) {
      if (!paare[i]) continue;
      var gleich = paare[i].indexOf('=');
      var k = gleich === -1 ? paare[i] : paare[i].slice(0, gleich);
      var v = gleich === -1 ? '' : paare[i].slice(gleich + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) {
        continue;
      }
      if (k === name) return v;
    }
    return null;
  }

  function vergleichAusSuche(suche, max) {
    return handlesAusText(parameter(suche, 'vergleich'), max);
  }

  // Ziel der Leiste: <Kollektions-URL>?vergleich=h1,h2,h3 (Kommas unkodiert, Handles sind URL-sicher)
  function vergleichsUrl(basis, handles) {
    return String(basis || '') + '?vergleich=' + handles.join(',');
  }

  // href mit gesetztem bzw. ersetztem Parameter (wert leer/null: entfernen); der Hash bleibt hinten
  function urlMitParam(href, name, wert) {
    var s = String(href || '');
    var hash = '';
    var h = s.indexOf('#');
    if (h !== -1) {
      hash = s.slice(h);
      s = s.slice(0, h);
    }
    var q = s.indexOf('?');
    var pfad = q === -1 ? s : s.slice(0, q);
    var teile = q === -1 ? [] : s.slice(q + 1).split('&').filter(function (p) {
      return p && p.split('=')[0] !== name;
    });
    if (wert !== null && wert !== undefined && wert !== '') teile.push(name + '=' + wert);
    return pfad + (teile.length ? '?' + teile.join('&') : '') + hash;
  }

  // Auswahl umschalten -> {liste, ergebnis: 'hinzu' | 'weg' | 'voll' | 'unveraendert'}; die Eingabe bleibt unveraendert
  function umschalten(liste, eintrag, an, max) {
    var grenze = max > 0 ? max : MAX_STANDARD;
    var neu = liste.slice();
    var i = -1;
    for (var k = 0; k < neu.length; k++) if (neu[k].h === eintrag.h) i = k;
    if (an) {
      if (i !== -1) return { liste: neu, ergebnis: 'unveraendert' };
      if (neu.length >= grenze) return { liste: neu, ergebnis: 'voll' };
      neu.push({ h: eintrag.h, t: eintrag.t || eintrag.h, b: eintrag.b || '' });
      return { liste: neu, ergebnis: 'hinzu' };
    }
    if (i === -1) return { liste: neu, ergebnis: 'unveraendert' };
    neu.splice(i, 1);
    return { liste: neu, ergebnis: 'weg' };
  }

  // Stabile Sortierung nach Auswahlen absteigend; ohne Wert (0) ans Ende, Gleichstand nach bisheriger Position
  function nachAuswahlen(eintraege) {
    return eintraege.map(function (e, i) {
      return { e: e, i: i };
    }).sort(function (a, b) {
      var x = Number(a.e.auswahlen) || 0;
      var y = Number(b.e.auswahlen) || 0;
      if (x !== y) return y - x;
      return a.i - b.i;
    }).map(function (w) {
      return w.e;
    });
  }

  // Speicherformat {v:1, k:{<kollektion>:[{h, t, b}]}} lesen: nur gueltige Handles, ohne Dubletten, hoechstens max
  function zustandLesen(text, kollektion, max) {
    var grenze = max > 0 ? max : MAX_STANDARD;
    var d = null;
    try {
      d = JSON.parse(text || 'null');
    } catch (e) {
      return [];
    }
    var roh = d && d.v === 1 && d.k && typeof d.k === 'object' && Array.isArray(d.k[kollektion]) ? d.k[kollektion] : [];
    var aus = [];
    roh.forEach(function (e) {
      if (!e || typeof e.h !== 'string' || !HANDLE.test(e.h) || aus.length >= grenze) return;
      for (var i = 0; i < aus.length; i++) if (aus[i].h === e.h) return;
      aus.push({ h: e.h, t: typeof e.t === 'string' && e.t ? e.t : e.h, b: typeof e.b === 'string' ? e.b : '' });
    });
    return aus;
  }

  // ... und schreiben; andere Kollektionen bleiben erhalten, eine leere Auswahl entfernt den Eintrag
  function zustandSchreiben(text, kollektion, liste) {
    var d = null;
    try {
      d = JSON.parse(text || 'null');
    } catch (e) {
      d = null;
    }
    if (!d || d.v !== 1 || !d.k || typeof d.k !== 'object') d = { v: 1, k: {} };
    if (liste.length) d.k[kollektion] = liste;
    else delete d.k[kollektion];
    return JSON.stringify(d);
  }

  var logik = {
    VERSION: VERSION,
    MAX_STANDARD: MAX_STANDARD,
    SPEICHER: SPEICHER,
    handlesAusText: handlesAusText,
    parameter: parameter,
    vergleichAusSuche: vergleichAusSuche,
    vergleichsUrl: vergleichsUrl,
    urlMitParam: urlMitParam,
    umschalten: umschalten,
    nachAuswahlen: nachAuswahlen,
    zustandLesen: zustandLesen,
    zustandSchreiben: zustandSchreiben
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.e2) return;

  var zustand = { kollektion: '', basis: '', max: MAX_STANDARD, liste: [] };

  function alle(selektor, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(selektor));
  }

  function leiste() {
    return document.querySelector('[data-mv-e2-leiste]');
  }

  // Handles sind per HANDLE geprueft, daher ohne Maskierung im Attributselektor
  function vorlage(h) {
    return document.querySelector('template[data-mv-e2-daten="' + h + '"]');
  }

  function wahlFeld(h) {
    return document.querySelector('[data-mv-e2-wahl="' + h + '"]');
  }

  function speicherLesen() {
    try {
      return window.sessionStorage.getItem(SPEICHER);
    } catch (e) {
      return null;
    }
  }

  function speichern() {
    try {
      window.sessionStorage.setItem(SPEICHER, zustandSchreiben(speicherLesen(), zustand.kollektion, zustand.liste));
    } catch (e) { /* privater Modus, Speicher voll */ }
  }

  // aria-live: erst leeren, dann setzen, damit dieselbe Meldung erneut vorgelesen wird
  function melden(text) {
    var el = document.querySelector('[data-mv-e2-meldung]');
    if (!el) return;
    el.textContent = '';
    window.setTimeout(function () {
      el.textContent = text;
    }, 30);
  }

  // Name und Bild zu einem Handle: Checkbox der Karte, sonst bisheriger Eintrag, sonst der Handle selbst
  function eintragFuer(h, bisher) {
    var feld = wahlFeld(h);
    if (feld) return { h: h, t: feld.getAttribute('data-mv-e2-titel') || h, b: feld.getAttribute('data-mv-e2-bild') || '' };
    for (var i = 0; i < bisher.length; i++) if (bisher[i].h === h) return bisher[i];
    return { h: h, t: h, b: '' };
  }

  function felderAbgleichen() {
    var gewaehlt = zustand.liste.map(function (e) {
      return e.h;
    });
    var voll = gewaehlt.length >= zustand.max;
    alle('[data-mv-e2-wahl]').forEach(function (feld) {
      var an = gewaehlt.indexOf(feld.getAttribute('data-mv-e2-wahl')) !== -1;
      if (feld.checked !== an) feld.checked = an;
      if (voll && !an) feld.setAttribute('aria-disabled', 'true');
      else feld.removeAttribute('aria-disabled');
    });
  }

  function leisteZeichnen() {
    var el = leiste();
    if (!el) return;
    var n = zustand.liste.length;
    el.hidden = n === 0;
    if (document.body) document.body.classList.toggle('mv-hat-vergleich', n > 0);
    var anzahl = el.querySelector('[data-mv-e2-anzahl]');
    if (anzahl) anzahl.textContent = String(n);
    var liste = el.querySelector('[data-mv-e2-liste]');
    if (liste) {
      liste.textContent = '';
      zustand.liste.forEach(function (e) {
        var li = document.createElement('li');
        li.className = 'mv-vergleichsleiste__eintrag';
        if (e.b) {
          var bild = document.createElement('img');
          bild.className = 'mv-vergleichsleiste__bild';
          bild.src = e.b;
          bild.alt = '';
          bild.width = 48;
          bild.height = 48;
          bild.setAttribute('loading', 'lazy');
          li.appendChild(bild);
        }
        var name = document.createElement('span');
        name.className = 'mv-vergleichsleiste__name';
        name.textContent = e.t || e.h;
        li.appendChild(name);
        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'mv-vergleichsleiste__entfernen';
        knopf.setAttribute('data-mv-e2-entfernen', e.h);
        knopf.setAttribute('aria-label', TEXT.entfernen + ': ' + (e.t || e.h));
        knopf.textContent = '\u00d7';
        li.appendChild(knopf);
        liste.appendChild(li);
      });
    }
    var link = el.querySelector('[data-mv-e2-link]');
    if (link) {
      if (n >= 2) {
        link.setAttribute('href', vergleichsUrl(zustand.basis, zustand.liste.map(function (e) {
          return e.h;
        })));
        link.removeAttribute('aria-disabled');
      } else {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      }
    }
    alle('[data-mv-e2-hinweis]', el).forEach(function (p) {
      var art = p.getAttribute('data-mv-e2-hinweis');
      p.hidden = !((art === 'mindestens' && n < 2) || (art === 'voll' && n >= zustand.max));
    });
    // Platz am Seitenende, damit die feste Leiste den Kontakt-Block und den Footer nicht verdeckt
    if (document.body && document.body.style) {
      var hoehe = el.offsetHeight || 0;
      if (n > 0 && hoehe > 0) document.body.style.setProperty('--mvs-e2-leiste-hoehe', hoehe + 'px');
      else if (n === 0) document.body.style.removeProperty('--mvs-e2-leiste-hoehe');
    }
  }

  function zeilen() {
    var t = document.querySelector('template[data-mv-e2-zeilen]');
    if (!t || !t.content) return [];
    return alle('[data-zeile]', t.content).map(function (el) {
      return { id: el.getAttribute('data-zeile'), label: el.textContent.replace(/^\s+|\s+$/g, '') };
    });
  }

  // Kopie einer Zelle aus der Vorlage einer Karte (ohne das Steuerattribut)
  function teil(t, id) {
    var el = t && t.content ? t.content.querySelector('[data-zeile="' + id + '"]') : null;
    if (!el) return null;
    var kopie = el.cloneNode(true);
    kopie.removeAttribute('data-zeile');
    return kopie;
  }

  function zelle(art, klasse) {
    var el = document.createElement(art);
    el.className = klasse;
    return el;
  }

  function ansichtZeichnen() {
    var ansicht = document.querySelector('[data-mv-e2-ansicht]');
    if (!ansicht) return;
    var wurzel = ansicht.closest('[data-mv-kollektion-kopf]');
    var spalten = vergleichAusSuche(window.location.search, zustand.max).map(function (h) {
      return { h: h, t: vorlage(h) };
    }).filter(function (s) {
      return s.t;
    });
    if (!spalten.length) {
      ansicht.hidden = true;
      if (wurzel) wurzel.removeAttribute('data-mv-e2-vergleich-aktiv');
      return;
    }
    ansicht.hidden = false;
    if (wurzel) wurzel.setAttribute('data-mv-e2-vergleich-aktiv', '');
    var hinweis = ansicht.querySelector('[data-mv-e2-ansicht-hinweis]');
    if (hinweis) hinweis.hidden = spalten.length >= 2;
    var ziel = ansicht.querySelector('[data-mv-e2-tabelle]');
    if (!ziel) return;

    var tabelle = zelle('table', 'mv-vergleichsansicht__tabelle');
    tabelle.setAttribute('data-spalten', String(spalten.length));
    var namen = [];
    var kopf = document.createElement('thead');
    var kopfzeile = document.createElement('tr');
    spalten.forEach(function (s) {
      var th = zelle('th', 'mv-vergleichsansicht__spalte');
      th.setAttribute('scope', 'col');
      var bild = teil(s.t, 'bild');
      if (bild) {
        bild.className = 'mv-vergleichsansicht__bildzelle';
        th.appendChild(bild);
      }
      var name = teil(s.t, 'titel');
      var text = name ? name.textContent.replace(/^\s+|\s+$/g, '') : s.h;
      namen.push(text);
      if (name) th.appendChild(name);
      var knopf = zelle('button', 'mv-vergleichsansicht__entfernen');
      knopf.type = 'button';
      knopf.setAttribute('data-mv-e2-entfernen', s.h);
      knopf.setAttribute('aria-label', TEXT.entfernen + ': ' + text);
      knopf.textContent = TEXT.entfernen;
      th.appendChild(knopf);
      kopfzeile.appendChild(th);
    });
    var titel = zelle('caption', 'mv-visually-hidden');
    titel.textContent = TEXT.vergleich + namen.join(', ');
    tabelle.appendChild(titel);
    kopf.appendChild(kopfzeile);
    tabelle.appendChild(kopf);

    zeilen().forEach(function (z) {
      var gruppe = zelle('tbody', 'mv-vergleichsansicht__gruppe');
      var merkmalzeile = document.createElement('tr');
      var merkmal = zelle('th', 'mv-vergleichsansicht__merkmal');
      merkmal.setAttribute('scope', 'rowgroup');
      merkmal.setAttribute('colspan', String(spalten.length));
      merkmal.textContent = z.label;
      merkmalzeile.appendChild(merkmal);
      gruppe.appendChild(merkmalzeile);
      var wertezeile = document.createElement('tr');
      spalten.forEach(function (s) {
        var td = zelle('td', 'mv-vergleichsansicht__wert');
        var inhalt = teil(s.t, z.id);
        if (inhalt) td.appendChild(inhalt);
        wertezeile.appendChild(td);
      });
      gruppe.appendChild(wertezeile);
      tabelle.appendChild(gruppe);
    });

    var aktionen = zelle('tbody', 'mv-vergleichsansicht__gruppe mv-vergleichsansicht__gruppe--aktionen');
    var aktionszeile = document.createElement('tr');
    spalten.forEach(function (s) {
      var td = zelle('td', 'mv-vergleichsansicht__wert');
      var a = teil(s.t, 'aktion');
      if (a) td.appendChild(a);
      aktionszeile.appendChild(td);
    });
    aktionen.appendChild(aktionszeile);
    tabelle.appendChild(aktionen);

    ziel.textContent = '';
    ziel.appendChild(tabelle);
  }

  function zeichnen() {
    felderAbgleichen();
    leisteZeichnen();
    ansichtZeichnen();
  }

  // In der Vergleichsansicht folgt die URL der Auswahl (ohne Auswahl entfaellt der Parameter)
  function urlNachziehen() {
    if (parameter(window.location.search, 'vergleich') === null) return;
    var handles = zustand.liste.map(function (e) {
      return e.h;
    });
    var neu = urlMitParam(window.location.pathname + window.location.search + window.location.hash, 'vergleich', handles.length ? handles.join(',') : null);
    try {
      window.history.replaceState(window.history.state, '', neu);
    } catch (e) { /* ohne History-API bleibt die URL stehen */ }
  }

  function aendern(eintrag, an) {
    var r = umschalten(zustand.liste, eintrag, an, zustand.max);
    if (r.ergebnis === 'voll') melden(TEXT.voll);
    if (r.ergebnis === 'hinzu' || r.ergebnis === 'weg') {
      zustand.liste = r.liste;
      speichern();
      urlNachziehen();
      melden((eintrag.t || eintrag.h) + (r.ergebnis === 'hinzu' ? TEXT.hinzu : TEXT.weg));
    }
    zeichnen();
    return r.ergebnis;
  }

  // Fokus nach dem Entfernen (der Knopf selbst ist neu gezeichnet und damit weg): Ueberschrift der Ansicht,
  // wenn aus der Tabelle entfernt wurde und sie noch steht, sonst Titel der Leiste, solange sie sichtbar ist
  function fokusNach(ausAnsicht) {
    var ansicht = document.querySelector('[data-mv-e2-ansicht]');
    var ziel = null;
    if (ausAnsicht && ansicht && !ansicht.hidden) ziel = ansicht.querySelector('h2[tabindex]');
    var el = leiste();
    if (!ziel && el && !el.hidden) ziel = el.querySelector('[data-mv-e2-leistentitel]');
    if (ziel && typeof ziel.focus === 'function') ziel.focus();
  }

  function sortieren() {
    if (parameter(window.location.search, 'sortierung') !== 'auswahlen') return;
    alle('[data-mv-e2-raster]').forEach(function (raster) {
      if (raster.getAttribute('data-mv-e2-sortiert') === 'auswahlen') return;
      // Paket K-9c: feste Zellen (data-mv-e2-fest) bleiben vor den sortierten stehen
      var zellen = Array.prototype.slice.call(raster.children).filter(function (z) {
        return !z.hasAttribute('data-mv-e2-fest');
      }).map(function (z) {
        var k = z.querySelector('[data-mv-auswahlen]');
        return { el: z, auswahlen: k ? parseInt(k.getAttribute('data-mv-auswahlen'), 10) || 0 : 0 };
      });
      nachAuswahlen(zellen).forEach(function (z) {
        raster.appendChild(z.el);
      });
      raster.setAttribute('data-mv-e2-sortiert', 'auswahlen');
    });
    alle('[data-mv-e2-sortierung]').forEach(function (chip) {
      if (chip.getAttribute('data-mv-e2-sortierung') === 'auswahlen') chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
    });
    alle('[data-mv-e2-filter] a[href]').forEach(function (a) {
      a.setAttribute('href', urlMitParam(a.getAttribute('href'), 'sortierung', 'auswahlen'));
    });
  }

  function init() {
    var el = leiste();
    if (el) {
      zustand.kollektion = el.getAttribute('data-mv-e2-kollektion') || '';
      zustand.basis = el.getAttribute('data-mv-e2-basis') || '';
      zustand.max = parseInt(el.getAttribute('data-mv-e2-max'), 10) || MAX_STANDARD;
      var gespeichert = zustandLesen(speicherLesen(), zustand.kollektion, zustand.max);
      var ausUrl = vergleichAusSuche(window.location.search, zustand.max).filter(function (h) {
        return vorlage(h) || wahlFeld(h);
      });
      zustand.liste = ausUrl.length ? ausUrl.map(function (h) {
        return eintragFuer(h, gespeichert);
      }) : gespeichert;
      if (ausUrl.length) speichern();
      zeichnen();
    } else {
      zustand.kollektion = '';
      zustand.liste = [];
    }
    sortieren();
  }

  document.addEventListener('change', function (e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-mv-e2-wahl]') : null;
    if (!feld || !zustand.kollektion) return;
    var h = feld.getAttribute('data-mv-e2-wahl') || '';
    if (!HANDLE.test(h)) return;
    aendern({ h: h, t: feld.getAttribute('data-mv-e2-titel') || h, b: feld.getAttribute('data-mv-e2-bild') || '' }, !!feld.checked);
  });

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target : null;
    if (!ziel || !zustand.kollektion) return;
    var weg = ziel.closest('[data-mv-e2-entfernen]');
    if (weg) {
      e.preventDefault();
      var h = weg.getAttribute('data-mv-e2-entfernen') || '';
      var ausAnsicht = !!weg.closest('[data-mv-e2-ansicht]');
      aendern(eintragFuer(h, zustand.liste), false);
      fokusNach(ausAnsicht);
      return;
    }
    if (ziel.closest('[data-mv-e2-leeren]')) {
      e.preventDefault();
      if (!zustand.liste.length) return;
      zustand.liste = [];
      speichern();
      urlNachziehen();
      zeichnen();
      melden(TEXT.leer);
      return;
    }
    var link = ziel.closest('[data-mv-e2-link]');
    if (link && link.getAttribute('aria-disabled') === 'true') e.preventDefault();
  });

  document.addEventListener('shopify:section:load', init); // Theme-Editor
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) init();
  });

  MV.e2 = {
    version: VERSION,
    logik: logik,
    init: init,
    auswahl: function () {
      return zustand.liste.slice();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
